import { messages as englishMessages } from "./en";
import { messages as spanishMessages } from "./es";
import { messages as hebrewMessages } from "./he";
import { messages as russianMessages } from "./ru";
import { messages as arabicMessages } from "./ar";

const messages = {
	...englishMessages,
	...spanishMessages,
	...hebrewMessages,
	...russianMessages,
	...arabicMessages,
};

export { messages };
